angular.module('cian.advancedBrowser')
.factory('AdvancedBrowserService', ["$http", function($http) {
  var service = {};

  return service;
}]);


// WEBPACK FOOTER //
// ./src/components/advanced-browser/src/scripts/cian.advanced-browser.service.js